import { useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { toJS } from 'mobx'

import { RoutingPaths } from 'app/routes/routes'

import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import { FilterTicketForm } from 'entities/ticket/models/find-ticket/models'

import {
  TYPE_BAGGAGE,
  TYPE_TRANSFERS,
  TypeRefundTicketAviaTypes,
} from 'shared/constants'
import { simpleIsEqual } from 'shared/lib/simpleIsEqual'

import { getIsActiveReset } from '../libs/getIsActiveReset'

export const useFilterState = () => {
  const navigate = useNavigate()

  const filter = findTicketFormStore.formFindTicket?.filter
  const filterDataFromRequest = findTicketFormStore.dataForFilter
  const priceRange = filterDataFromRequest?.priceRange

  const [initialState] = useState<FilterTicketForm>(() => {
    const plainFilter = toJS(filter)
    const plainPriceRange = toJS(priceRange)

    return {
      ...plainFilter,
      rangePrice: plainFilter?.rangePrice || {
        max: plainPriceRange?.max || 0,
        min: plainPriceRange?.min || 0,
      },
    }
  })

  const [state, setState] = useState<FilterTicketForm>(initialState)

  const hasActiveFilters = getIsActiveReset(state, filterDataFromRequest)
  const hasChanges = !simpleIsEqual(state, initialState)
  const isDisabledComfort = state.transfers === TYPE_TRANSFERS.WITHOUT

  const onReset = () => {
    setState({
      rangePrice: {
        max: priceRange?.max || 0,
        min: priceRange?.min || 0,
      },
    })
  }

  const onResetFields = (fields: (keyof FilterTicketForm)[]) => {
    setState((prev) => {
      const newState = { ...prev }

      fields.forEach((field) => {
        if (field === 'rangePrice') {
          newState.rangePrice = {
            max: priceRange?.max || 0,
            min: priceRange?.min || 0,
          }
        } else {
          newState[field] = undefined as any
        }
      })

      return newState
    })
  }

  const onChangeTransfer = (value: TYPE_TRANSFERS) => {
    if (value === TYPE_TRANSFERS.WITHOUT) {
      setState((prev) => ({
        ...prev,
        transfers: value,
        durationOfTransfers: undefined,
      }))
      return
    }

    setState((prev) => ({ ...prev, transfers: value }))
  }

  const onChangeBaggage = (value: string) => {
    setState((prev) => ({ ...prev, baggage: value as TYPE_BAGGAGE }))
  }

  const onChangeTypeRefund = (value: string) => {
    setState((prev) => ({
      ...prev,
      refundTicket: value as TypeRefundTicketAviaTypes,
    }))
  }

  const onChangePriceFilter = (dataRange: number[]) => {
    setState((prev) => ({
      ...prev,
      rangePrice: { min: dataRange[0], max: dataRange[1] },
    }))
  }

  const onChangeComfortFilter = (data: FilterTicketForm) => {
    setState(data)
  }

  const onSubmit = () => {
    navigate(RoutingPaths.avia.search.path())
    findTicketFormStore.onSetFilter(state)
  }

  return {
    state,
    setState,
    filter,
    filterDataFromRequest,
    priceRange,
    hasActiveFilters,
    hasChanges,
    isDisabledComfort,
    onReset,
    onResetFields,
    onChangeTransfer,
    onChangeBaggage,
    onChangeTypeRefund,
    onChangePriceFilter,
    onChangeComfortFilter,
    onSubmit,
  }
}
